export default {"src":"/_next/static/media/coworking-icon.d9adaa4f.svg","height":96,"width":59,"blurWidth":0,"blurHeight":0};